// 葡萄牙
const por = {
  描述:"Descrições",
  图片: 'Fotografia',
  名称: 'Nome',
  产品编码: 'Código Do Produto',
  总数: 'Agregado',
  件数: 'Contagem De Itens',
  home: 'Página Inicial',
  用户账号: 'Conta De Utilizador',
  昵称: 'Apelido',
  product: 'Produtos',
  产品分类: 'Produtos',
  新商品: 'Novos Produtos',
  // 降价产品: 'Produtos De Redução De Preços',
  全部分类: 'Classificar Todos',
  返回首页: 'Voltar à Página Inicial',
  注册: 'Registo',
  我的账户: 'Minha Conta',
  我的采购单: 'Encomendas',
  // 欢迎光临舱多保产品库: 'Bem-vindo à Biblioteca De Produtos Hongxu',
  欢迎光临舱多保产品库:'Bem-vindo à Biblioteca De Produtos Da Hatch Turbine',
  你好请登录: 'Olá. Por Favor, Faça Login',
  请输入您想要搜索的内容: 'Por Favor, Insira O Conteúdo Que Deseja Pesquisar',
  login: 'Olá, Por Favor Faça O Login',
  search: 'Pesquisar',
  exit: 'Sair',
  爆款推荐: 'Recomendações Mais Vendidas',
  新产品: 'Novos Produtos',
  降价产品: 'Bens De Redução De Preços',
  人付款: 'Pessoa',
  加入购物车: 'Adicionar Ao Carrinho',
  登录: 'Iniciar Sessão',
  收藏夹: 'Favoritos Em',
  个人中心: 'Um Pessoal',
  首页: 'Ficha Técnica',
  价格筛选: 'Filtrar',
  更多: 'Mais',
  由高到低: 'Maior Para Menor',
  由低到高: 'Menor Para Maior',
  上一页: '<  Anterior',
  下一页: 'Próxima  >',
  爆款: 'Rebentar',
  产品编码: 'Código Do Produto',
  装箱数: 'Caixas',
  每箱体积: 'Volume Por Caixa',
  每箱重量: 'Peso Por Caixa',
  分类: 'Classificação',
  最小起订箱: 'Caixa De Ordem Mínima',
  数量: 'Quantidade',
  箱: 'Caixa',
  加入常购清单: 'Lista De Compras',
  收藏: 'Eecolha',
  订单中心: 'Centro De Pedidos',
  // 我的采购单: 'Meu formulário de compra',
  常购清单: 'Lista De Compras Frequentes',
  账户管理: 'Gestão De Contas',
  个人信息: 'Informações Pessoais',
  收货地址: 'Endereço De Entrega',
  修改密码: 'Mudar A Senha',
  我的留言: 'Minha Mensagem',
  申请开店: 'Aplicar Para Abrir Uma Loja',
  全部: 'Inteiro',
  修改个人信息: 'Modificar Informações Pessoais >',
  请输入订单编号: 'Introduzir O Número De Encomenda Do Produto',
  商品: 'Commodity',
  单价: 'Preço Unitário',
  数量: 'Quantidade',
  操作: 'Operação',
  订单号: 'Número De Ordem',
  订单状态: 'Estado Da Ordem',
  已下单: 'Já Encomendado',
  处理中: 'Em Processamento',
  已发货: 'Já Enviado Para',
  已完成: 'Já Foi Concluído',
  已取消: 'Já Foi Cancelado',
  订单取消: 'Já Foi Cancelado',
  已提交: 'Já Foi Submetido',
  下单时间: 'Hora Da Ordem',
  支付状态: 'Estado Do Pagamento',
  待支付: 'Pagamento Pendente',
  已支付: 'Pago',
  交易成功: 'Sucesso Na Negociação',
  物流运输中: 'Logística E Transporte Em',
  订单详情: 'Detalhes Da Ordem',
  取消: 'Cancelar',
  确认收货: 'Confirmação',
  订单完成: 'Conclusão Do Pedido',
  订单总额: 'Total Da Ordem',
  打印: 'Imprimir',
  导出: 'Exportação',
  下载: 'Descarregar',
  配送地址: 'Endereço De Entrega',
  收货地址: 'Endereço De Entrega',
  姓名: 'Nome',
  电话号码: 'Telefone',
  公司名称: 'Nome Empresa',
  邮政编码: 'Cep Código Postal',
  详细地址: 'Endereço',
  配送: 'Distribuição',
  配送方式: 'Formas De Entrega',
  货运信息: 'Informações Sobre Frete',
  船运: 'Navegação',
  空运: 'Transporte Aéreo',
  付款方式: 'Formas De Pagamento',
  支付信息: 'Informações De Pagamento',
  收款公司: 'Empresa De Cobrança',
  收款账号: 'Número Da Conta',
  收款银行: 'Banco De Recebimento',
  公司地址: 'Endereço Da Empresa',
  银行地址: 'Endereço Do Banco',
  付款凭证: 'Comprovante De Pagamento',
  商品清单: 'Lista De Bens',
  商品图片: 'Imagem',
  商品编码: 'Codificação',
  商品名称: 'Nome',
  箱数: 'Número De Casos',
  体积: 'Volume',
  重量: 'Peso',
  金额: 'Montante',
  总重量: 'Peso Peso Total',
  总体积: 'Volume Total',
  总金额: 'Quantidade Total Disponível',
  全选: 'Cobrir Todos',
  删除: 'Apagar',
  批量管理: 'Gestão De Lotes',
  导入常购清单: 'Importar Lista De Compras Frequentes',
  性别: 'Sexo',
  男: 'Homens',
  女: 'Mulheres',
  保密: 'Confidencialidade',
  出生日期: 'Data De Nascimento',
  选择日期: 'Escolha Uma Data',
  头像: 'Cabeça',
  邮箱: 'Caixa De Correio',
  个性签名: 'Assinatura De Personalidade',
  保存: 'Conservação',
  您已创建: 'Você Criou',
  个收货地址: 'Um Endereço De Entrega',
  最多可创建: 'Pode Criar Até',
  个: 'Um',
  新增收货地址: 'Nova',
  传真号码: 'Fax',
  地址: 'Endereço',
  编辑: 'Editor',
  所在地区: 'Região Onde Está',
  请选择: 'Selecione',
  修改密码: 'Alterar Sua Senha',
  当前密码: 'Senha Atual',
  新密码: 'Nova Palavra-Passe',
  确认密码: 'Confirme A Senha',
  日期: 'Data',
  回复: 'Resposta',
  留言: 'Mensagem',
  请输入内容: 'Por Favor Insira O Conteúdo',
  提交: 'Apresentação',
  联系人: 'Contato',
  联系电话: 'Telefone De Contato',
  手机号码: 'Número De Celular',
  申请入驻: 'Pedido De Admissão',
  购物车: 'Carrinho',
  全部: 'Todos',
  件: 'Um',
  已选择: 'Selecionado',
  移入收藏夹: 'Ir Para Favoritos',
  去付款: 'Pagamentos',
  结账: 'Facturação',
  选择收货地址: 'Escolha Um Endereço De Entrega',
  管理收货地址: 'Gerenciar Endereços De Entrega',
  选择配送方式: 'Escolha O Método De Entrega',
  支付信息: 'Informação De Pagamento',
  确认: 'Confirmação',
  留言管理: 'Gestão De Mensagens',
  标题: 'Título',
  留言内容: 'Conteúdo',
  请输入用户名: 'Nome De Usuário',
  请输入密码: 'Senha',
  忘记密码: 'Esqueci Minha Senha',
  记住我: 'Lembre-se De Mim',
  进入官网: 'Acesse O Site Oficial',
  请正确输入邮箱: 'Por Favor Insira O Email Corretamente',
  密码必须是的非空字符: 'A Senha Deve Ter Entre 6 E 18 Caracteres Não Nulos',
  找回密码: 'Recupere Sua Senha',
  输入请您的邮箱: 'Digite Seu E-mail',
  请输入注册邮箱: 'Por Favor Insira O E-mail Cadastrado',
  下一步: 'Próximo Passo',
  请正确输入邮箱: 'Por Favor Insira O Email Corretamente',
  验证信息: 'Verifique A Informação',
  设置新密码: 'Definir Nova Senha',
  重置成功: 'Redefinir Com Sucesso',
  验证码已发送至: 'Enviado Para',
  请输入邮箱内验证码进行重置密码: 'Introduza O Código De Verificação',
  请输入验证码: 'Por Favor Insira O Captcha',
  发送验证码: 'Enviar',
  重新发送: 'Retransmissão',
  验证码不能为空: 'Captcha Não Pode Estar Vazio',
  两次输入的密码不一致: 'Duas Senhas Digitadas São Incoerentes',
  请再次输入密码: 'Por Favor, Digite A Senha Novamente',
  恭喜您密码重置成功快去登录吧: 'Parabéns Por Redefinir Sua Senha Com Sucesso.',
  登陆: 'Autenticação',
  商品详情: 'Detalhes Da Mercadoria',
  推荐商品: 'Recomende Um Item',
  成功加入收藏夹: 'Adicionado Aos Favoritos Com Sucesso',
  成功加入常购清单: 'Adicionado Com Sucesso à Lista De Compras Frequentes',
  添加成功: 'Adicionado Com Sucesso',
  您还未登录即将跳转登录页面:
    'Você Não Está Logado Em Breve Ir Para A Página De Login',
  请选择商品再结算: 'Por Favor, Selecione A Mercadoria Para Re-liquidação',
  下单成功: 'Ordem Colocada Com Sucesso',
  请输入留言标题: 'Digite O Título Da Mensagem',
  请输入留言内容: 'Digite O Conteúdo Da Mensagem',
  提交成功: 'Enviado Com Sucesso',
  修改成功: 'Modificado Com Sucesso',
  密码修改成功即将重新登录:
    'Senha Alterada Com Sucesso Entrar Novamente Em Breve',
  请检查当前密码输入是否正确:
    'Compruebe Que La Contraseña Actual Haya Sido Introducida Correctamente',
  回复成功: 'Resposta Bem Sucedida',
  请输入回复内容: 'Por Favor, Digite O Conteúdo Da Resposta',
  上传头像图片只能是JPGJPEGPNG格式:
    'Carregar A Imagem Do Avatar Só Pode Ser No Formato JPG、JPEG、PNG',
  上传头像图片大小不能超过2MB: 'Carregar Imagem De Avatar Não Deve Exceder 2MB',
  请输入姓名: 'Por Favor Insira Um Nome',
  请输入出生年月日: 'Por Favor Insira O Dia E Mês De Nascimento',
  请上传头像: 'Por Favor Carregue Seu Avatar',
  请输入公司名称: 'Por Favor Insira O Nome Da Empresa',
  请输入电话号码: 'Por Favor Insira O número De Telefone',
  请输入个性签名: 'Por Favor, Insira Uma Assinatura De Personalidade',
  请选择性别: 'Por Favor, Selecione O Sexo',
  请输入邮箱: 'Por Favor Insira Um Email',
  个人信息保存成功: 'Informações Pessoais Salvas Com Sucesso',
  您的入驻申请通过: 'Seu Pedido De Admissão é Feito Através',
  您的入驻申请正在审核中: 'Seu Pedido De Admissão Está Sendo Analisado',
  您的入驻申请未通过未通过的原因为:
    'O Seu Pedido De Admissão Não Foi Aprovado. O Motivo Do Fracasso é',
  请输入手机号码: 'Digite O Número De Celular',
  请输入联系电话: 'Por Favor Insira Um Número De Contato',
  请输入联系人: 'Por Favor Insira Um Contato',
  您的开店申请以提交请等待审核:
    'Seu Pedido De Abertura De Loja Para Enviar Aguarde A Revisão',
  邮箱注册: 'Cadastro Por Email',
  微信: 'WeChat',
  电话: 'Telefone',
  回顶部: 'Topo',
  打开微信: 'Abra Wechat',
  扫码添加客服: 'Esaú Metros',
  综合: 'Síntese',
  销量: 'Vendas',
  新品: 'Lançamento',
  价格: 'Preços',
  更多: 'Mais',
  请上传文件材料: 'Carregar Documentação',
  舱多保供应链版权所有:
    'Todos Os Direitos Reservados Para Chaiduobao Supply Chain',
  您的订单已经处理成功订单号:
    'Your Order Has Been Processed Successfully Order Number',
  查看订单: 'Ver O Pedido',
  导入购物车: 'Carrinho De Importação',
  销量筛选: 'Filtro De Vendas',
  MOQ: '',
  SetS: '',
  共有: 'Total',
  转到购物车: 'Ir Para O Carrinho',
  生成采购单: 'Gerar Ordens De Compra',
  暂无发货清单: 'Sem Lista De Expedição',
  发货清单:'Lista De Expedição',
  导出Excel: 'Exportar Excel',
  符号:'$',
  language: {
    zh: '中文',
    en: 'English',
    es: 'Español',
    por: 'Português'
  }
}
export default por
